import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { CheckSignedDocumentService } from '../../../core/services/check-signed-document.service';
import { DocumentToSignHistoryModel } from '../../../models/documentToSignHistoryModel';

@Component({
    selector: 'app-check-signed-document',
    templateUrl: './check-signed-document.component.html',
    standalone: false
})
export class CheckSignedDocumentComponent {

  history: DocumentToSignHistoryModel[];
  errorMessage: string;
  canEmailClients = false;
  isEmailSending = false;
  emailMessage: string;
  documentToSignID: string;

  constructor(private checkSignedDocumentService: CheckSignedDocumentService, private route: ActivatedRoute) {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        this.history = null;
        this.errorMessage = null;
        this.canEmailClients = false;
        this.emailMessage = null;
        this.documentToSignID = params.get('documentToSignID');
        return forkJoin({
          history: this.checkSignedDocumentService.getDocumentHistory(this.documentToSignID),
          canEmail: this.checkSignedDocumentService.canEmailClients(this.documentToSignID).pipe(catchError(() => of(false)))
        });
      })
    ).subscribe({
      next: result => { this.history = result.history; this.canEmailClients = result.canEmail; },
      error: (error: string) => {
        // The error interceptor returns the server message JSON-encoded
        try {
          const message = JSON.parse(error);
          this.errorMessage = typeof message === 'string' ? message : 'The document history could not be loaded.';
        } catch {
          this.errorMessage = error;
        }
      }
    });
  }

  emailClients() {
    if (this.isEmailSending) return;
    const id = this.documentToSignID;
    this.isEmailSending = true;
    this.emailMessage = null;
    this.checkSignedDocumentService.emailClients(id).pipe(finalize(() => this.isEmailSending = false)).subscribe({
      next: () => {
        if (id === this.documentToSignID) this.emailMessage = 'New 14-day history links were emailed to the currently authorized client participants.';
      },
      error: error => {
        if (id !== this.documentToSignID) return;
        try { this.emailMessage = JSON.parse(error); }
        catch { this.emailMessage = typeof error === 'string' ? error : 'The history emails could not be sent. Please try again or contact support.'; }
      }
    });
  }
}
